import React from "react";
import { Redirect } from "react-router-dom";
import MainContent from "./MainContent";
import Callout from "./Callout";
import ContactHelp from "./ContactHelp";
import { FadeUp, GrowToFullSize } from "./AnimationLibrary";

const Success = props => {
	if (!props.user || !props.user.netid) return <Redirect push from="/success" to="/"/>;

	return (
		<>
			<MainContent user={props.user} sideBar={true}>
				<FadeUp delay="0">
					<h2 className="main-heading">Success</h2>
				</FadeUp>
				<div className="main-message-container">
					<FadeUp delay="150">
						<SuccessMessage user={props.user} />
					</FadeUp>
					<GrowToFullSize delay="250">
						<a className="btn" href="https://home.dartmouth.edu">
							Exit to
							<img className="d-pine" src="../images/d-pine.png" alt="Dartmouth D-Pine"/>
							Homepage
						</a>
					</GrowToFullSize>
				</div>
			</MainContent>
			<ContactHelp />
		</>
	);
};

const SuccessMessage = props => {
	if(props.user.primaryAffiliation.toLowerCase() === "alum") { 
		return (
			<p className="intro-text">
				Your new password has been set. You can now return to the service you wanted to access and use your new password.
			</p>
		)
	}

	return (
		<>
			<p className="intro-text">Your new password has been set.</p>
			<Callout>
				Now that your password has changed, you may need to update saved passwords on your other devices.
			</Callout>
			<p>
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://services.dartmouth.edu/TDClient/1806/Portal/KB/ArticleDet?ID=105925"
				>
					Learn about the effects of changing your password
				</a>.
			</p>
		</>
	)
}

export default Success;
